/**
 * Vehicle damage status values
 */
export enum VehicleDamageStatusEnum {
	/**
	 * Vehicle damage is pending
	 */
	PENDING = 'pending',
	/**
	 * Vehicle damage is repaired
	 */
	REPAIRED = 'repaired',
	/**
	 * Vehicle damage is ignored
	 */
	IGNORED = 'ignored',
}
